module.exports = __webpack_public_path__ + "img/New PACI Flow - New User AR - 7.86c78e14.png";